import { render, staticRenderFns } from "./AuthorizationDocuSign.vue?vue&type=template&id=18d09128&scoped=true&"
import script from "./AuthorizationDocuSign.vue?vue&type=script&lang=js&"
export * from "./AuthorizationDocuSign.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationDocuSign.vue?vue&type=style&index=0&id=18d09128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d09128",
  null
  
)

export default component.exports